import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["search", "teamTypeId", "teamIds", "contentIds", "userIds", "includeCalculatedTeams", "filter"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useInfiniteQuery } from '@tanstack/react-query';
import api from 'utils/api';
import toArray from 'utils/toArray';
import { teamQueryKeys } from '.';

// Not adding a type due to it being a Dare obj
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function formatTeamListItem(obj) {
  var _obj$contentTeams;
  obj.is_deleted = Boolean(+obj.is_deleted) || false;
  obj.isSmartTeam = Boolean(+obj.isSmartTeam);
  obj.contentTeams = (_obj$contentTeams = obj.contentTeams) === null || _obj$contentTeams === void 0 ? void 0 : _obj$contentTeams.map(function (ct) {
    ct.isCalculated = Boolean(+ct.isCalculated);
    return ct;
  });
  return obj;
}
function useFetchTeams(_ref) {
  var _data$pages;
  var search = _ref.search,
    teamTypeId = _ref.teamTypeId,
    teamIds = _ref.teamIds,
    contentIds = _ref.contentIds,
    userIds = _ref.userIds,
    _ref$includeCalculate = _ref.includeCalculatedTeams,
    includeCalculatedTeams = _ref$includeCalculate === void 0 ? false : _ref$includeCalculate,
    filter = _ref.filter,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function queryFn(_x) {
    return _queryFn.apply(this, arguments);
  }
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var pageParam, user_ids, fields, hasUserIds, requestQuery, _yield$api, items, next;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            pageParam = _ref2.pageParam;
            user_ids = toArray(userIds).filter(Boolean);
            fields = ['id', 'name', {
              teamType: ['id', 'name', 'colour']
            }, 'smart_settings', 'isSmartTeam', {
              contentTeams: ['isCalculated']
            }];
            hasUserIds = user_ids.length !== 0;
            if (hasUserIds) {
              fields.push({
                userTeams: ['role']
              });
            }
            requestQuery = pageParam || {
              fields: fields,
              orderby: 'name',
              filter: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, filter), search && {
                name: "%".concat(search, "%")
              }), teamTypeId && {
                teamType_id: teamTypeId
              }), Array.isArray(teamIds) && {
                id: teamIds
              }),
              join: _objectSpread({
                contentTeams: {
                  isCalculated: includeCalculatedTeams ? [0, 1] : [0],
                  assetDomains: _objectSpread({
                    _required: true
                  }, Array.isArray(contentIds) && {
                    asset_id: contentIds
                  })
                }
              }, hasUserIds && {
                userTeams: {
                  user_id: userIds
                }
              })
            };
            _context.next = 1;
            return api('get', '/api/query/team', requestQuery);
          case 1:
            _yield$api = _context.sent;
            items = _yield$api.items;
            next = _yield$api.next;
            return _context.abrupt("return", {
              items: items,
              next: next
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var queryKey = teamQueryKeys.teams({
    teamIds: teamIds,
    search: search,
    teamTypeId: teamTypeId,
    contentIds: contentIds,
    filter: filter,
    userIds: userIds
  });
  var _useInfiniteQuery = useInfiniteQuery(_objectSpread(_objectSpread({
      queryKey: queryKey,
      queryFn: queryFn,
      initialPageParam: undefined
    }, queryOptions), {}, {
      getNextPageParam: function getNextPageParam(lastPage) {
        return lastPage.next;
      },
      staleTime: 60 * 1000
    })),
    data = _useInfiniteQuery.data,
    result = _objectWithoutProperties(_useInfiniteQuery, _excluded2);
  var items = (data === null || data === void 0 || (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.filter(function (page) {
    return page.items;
  }).flatMap(function (page) {
    return page.items;
  })) || [];
  return _objectSpread({
    items: items.map(formatTeamListItem)
  }, result);
}
export default useFetchTeams;